export const getHashValue = (hash: string) => hash?.replace('#', '');
